<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white m-3 rounded-b-md">
      <div class="border-b-0.5 flex flex-col gap-3 w-full items-left p-3">
        <!--  v-if="!removeUnnecessaryBtn" -->
        <router-link
          :to="{
            name: 'company-setups',
            params: {
              type: 'time-off-journals',
              outerTab: 4,
              innerTab: 3,
              company: getOrganization,
            },
          }"
          class="flex items-center gap-2 rounded-full w-max p-2 justify-center text-sm bg-gray-200"
        >
          <img class="h-4 object-contain" src="@/assets/icons/left.png" />
          <p>Back to Journals</p>
        </router-link>

        <div class="flex flex-col gap-1">
          <p class="flex gap-2">
            Journal Code:
            <span class="font-bold">{{ getCurrentJournalId.Code }}</span>
          </p>
          <p class="flex gap-2">
            Journal Name:
            <span class="font-bold">{{ getCurrentJournalId.Name }}</span>
          </p>
        </div>
      </div>

      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">
          List of Time Off Journal Entries
        </p>
      </div>
      <div class="border-b-0.5 flex justify-between items-center p-2">
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <button
            @click="showCreateTimeoffJournal = true"
            class="bg-primary text-white rounded-full px-3 py-1 text-sm"
          >
            Create
          </button>
          <button
            @click="showBulkUpload = true"
            class="border-1.5 rounded-full p-1.5 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Import
          </button>
          <button
            @click="exportTemplate"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Export
          </button>

          <div v-if="showToolbar" class="flex px-2 gap-5">
            <!-- Post Icon -->
            <div
              class="cursor-pointer"
              @mouseover="togglePostIcon = true"
              @mouseout="togglePostIcon = false"
            >
              <el-popover placement="top" width="210" v-model="postVisible">
                <p style="font-size: 0.7rem !important">
                  This action is permanent. Do you want to proceed?
                </p>
                <div
                  style="
                    text-align: right;
                    margin: 1rem 0;
                    font-size: 0.8rem !important;
                  "
                >
                  <el-button
                    size="mini"
                    @click="postVisible = false"
                    style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
                  >
                    No
                  </el-button>
                  <el-button
                    type="warning"
                    size="mini"
                    @click="postJournal()"
                    style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
                  >
                    Yes
                  </el-button>
                </div>
                <button
                  type="success"
                  title="Post selected entries"
                  slot="reference"
                  class="flex items-center bg-primary text-white rounded-full px-3 py-1 text-sm"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Outline"
                    viewBox="0 0 24 24"
                    class="h-4 mr-1"
                  >
                    <path
                      d="M19,0H5A5.006,5.006,0,0,0,0,5V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V5A5.006,5.006,0,0,0,19,0Zm3,19a3,3,0,0,1-3,3H5a3,3,0,0,1-3-3V5A3,3,0,0,1,5,2H19a3,3,0,0,1,3,3Z"
                    />
                    <path
                      d="M9.333,15.919,5.414,12A1,1,0,0,0,4,12H4a1,1,0,0,0,0,1.414l3.919,3.919a2,2,0,0,0,2.829,0L20,8.081a1,1,0,0,0,0-1.414h0a1,1,0,0,0-1.414,0Z"
                    />
                  </svg>
                  <span>Post</span>
                </button>
              </el-popover>
            </div>

            <!-- Delete Icon -->
            <div
              class="cursor-pointer"
              @mouseover="toggleDeleteIcon = true"
              @mouseout="toggleDeleteIcon = false"
            >
              <el-popover placement="top" width="210" v-model="deleteVisible">
                <p style="font-size: 0.7rem !important">
                  This action is permanent. Do you want to proceed?
                </p>
                <div
                  style="
                    text-align: right;
                    margin: 1rem 0;
                    font-size: 0.8rem !important;
                  "
                >
                  <el-button
                    size="mini"
                    @click="deleteVisible = false"
                    style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
                    >No</el-button
                  >
                  <el-button
                    type="warning"
                    size="mini"
                    @click="deleteEntry()"
                    style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
                    >Yes</el-button
                  >
                </div>
                <button
                  type="warning"
                  title="Delete selected entries"
                  slot="reference"
                  class="flex items-center bg-primary text-white rounded-full px-3 py-1 text-sm"
                >
                  <img
                    v-if="!toggleDeleteIcon"
                    class="h-4 object-contain cursor-pointer mr-1"
                    src="@/assets/icons/delete.png"
                  />
                  <img
                    v-else
                    class="h-4 object-contain cursor-pointer mr-1"
                    src="@/assets/icons/recycle-bin.png"
                  />
                  <span>Delete</span>
                </button>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="px-2 pb-2">
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ del_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="create_success"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <div>
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
              <loader class="center-h-v" />
            </div>
          </transition>
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
            row-key-field-name="TimeoffJournalLineId"
            :checkbox-option="checkboxOption"
          />

          <ve-table
            :columns="columns"
            :tableData="tableData"
            v-if="!searchInput.length"
            row-key-field-name="TimeoffJournalLineId"
            :checkbox-option="checkboxOption"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No Entries found
          </p>
        </div>
      </div>
    </div>
    <!-- create -->
    <CreateTimeoffJournal
      @close="showCreateTimeoffJournal = false"
      :showCreateTimeoffJournal="showCreateTimeoffJournal"
      @closeOnSuccess="handleCloseOnSuccess"
      :reload="reload"
    ></CreateTimeoffJournal>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>

    <!-- Create multiple ledger entries -->
    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      title="Upload Timeoff Journal"
      dataType="UploadTimeoffJournalLine"
      :url="url"
      :dateColumns="['StartDate', 'EndDate']"
      :columns="timeoffJournalBulkUploadColumns"
    ></BulkUpload>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../utils/actionWarning.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import CreateTimeoffJournal from "@/components/CompanySetups/timeOffSetups/create.vue";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import timeoffJournalBulkUploadColumns from "@/data/timeoffJournalBulkUploadColumns";
import decryptData from "@/utils/decrypt";

export default {
  name: "timeOffJournalsList",
  components: {
    Loader,
    CreateTimeoffJournal,
    ActionWarning,
    BulkUpload: () => import("@/utils/bulkUploadsUtils.vue"),
  },

  data() {
    return {
      actionEntries: null,
      showToolbar: false,
      deleteVisible: false,
      postVisible: false,
      toggleDeleteIcon: false,
      togglePostIcon: false,
      showDeletePopover: false,
      url: `/timeoff/journal/line/${this.$ApiVersion}/upload`,
      showBulkUpload: false,
      showCreateTimeoffJournal: false,
      showEditLeaveType: false,
      loading: false,
      get_error: null,
      create_success: null,
      del_success: null,
      del_error: null,
      info: null,
      message: null,
      title: null,
      searchInput: "",
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      journalToDelete: null,
      showWarning: false,
      leaveTypeToEdit: {},
      timeoffJournalBulkUploadColumns: null,
      columns: [
        {
          field: "",
          key: "checkbox",
          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 10,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        {
          field: "Type",
          key: "type",
          title: "Entry Type",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => row.Type.split(/(?=[A-Z])/).join(" "),
          sampleValue: "Brought Forward",
        },

        {
          field: "EmployeeId",
          key: "employeeNumber",
          title: "Employee No",
          headerAlign: "left",
          align: "left",
          sampleValue: "EMPLOYEE-01",
        },

        {
          field: "EmployeeName",
          key: "EmployeeName",
          title: "Employee",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            decryptData(row.EmployeeName, this.$decryptionKey),
        },

        {
          field: "LeaveTypeName",
          key: "leavetypeid",
          title: "Timeoff Type",
          headerAlign: "left",
          align: "left",
          sampleValue: "Annual",
        },

        {
          field: "StartDate",
          key: "StartDate",
          title: "Start Date",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) =>
            moment(row.StartDate).format("DD/MM/YYYY"),
          sampleValue: moment(new Date()).format("DD/MM/YYYY"),
        },
        {
          field: "EndDate",
          key: "EndDate",
          title: "End Date",
          headerAlign: "left",
          align: "left",
          renderBodyCell: ({ row }) => moment(row.EndDate).format("DD/MM/YYYY"),
          sampleValue: moment(new Date()).format("DD/MM/YYYY"),
        },
        {
          field: "LeavePeriodName",
          key: "leaveperiodid",
          title: "Leave Period",
          headerAlign: "center",
          align: "center",
          renderBodyCell: () =>
              "Period Name"
        },
        {
          field: "Days",
          key: "days",
          title: "Days",
          headerAlign: "center",
          align: "center",
          sampleValue: (Math.random() * 10).toFixed(2),
        },
        {
          field: "Posted",
          key: "Posted",
          title: "Posted",
          headerAlign: "center",
          align: "center",
          renderBodyCell: ({ row }) => (
            <VeCheckbox v-model={row.Posted}></VeCheckbox>
          ),
        },
        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-1 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() =>
                    this.handlePostButtonClick(row.TimeoffJournalLineId)
                  }
                >
                  Post
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],

      checkboxOption: {
        // row select change event
        selectedRowChange: ({ isSelected, selectedRowKeys }) => {
          this.showToolbar = isSelected;
          this.actionEntries = selectedRowKeys;
        },
        // selected all change event
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          isSelected;

          this.showToolbar = selectedRowKeys.length > 0;

          // this.showToolbar = isSelected;
          this.actionEntries = selectedRowKeys;
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentJournalId"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
  },
  created() {
    // this.getJournal();
    this.tableData = this.getCurrentJournalId.TimeoffJournalLines;
    this.timeoffJournalBulkUploadColumns = timeoffJournalBulkUploadColumns;
  },
  methods: {
    deleteEntry() {
      this.actionEntries.forEach((timeoffJournalLineId) => {
        this.deleteJournalEntry(timeoffJournalLineId);
      });
    },
    postJournal() {
      this.actionEntries.forEach((timeoffJournalLineId) => {
        this.handlePostButtonClick(timeoffJournalLineId);
      });
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getJournal();
    },

    // bulk operations
    exportTemplate() {
      let templateColumns = [
        ...this.columns.filter(
          (n) =>
            n.title !== "#" &&
            n.field !== "EmployeeName" &&
            n.field !== "Posted" &&
            n.field !== "" &&
            n.field !== "LeavePeriodName"
        ),
      ];

      templateColumns.push({
        field: "TimeoffJournal",
        key: "timeoffJournal",
        title: "Timeoff Journal",
        headerAlign: "left",
        align: "left",
        sampleValue: "Existing Employees",
      });

      importTemplateGenerator(
        templateColumns,
        "UploadTimeoffJournalLine",
        [],
        false,
        false
      );
    },

    handleClose() {
      this.showCreateTimeoffJournal = false;
      this.showEditLeaveType = false;
    },
    handleCloseOnSuccess() {
      this.showCreateTimeoffJournal = false;
      this.showLocCrSuccess = false;
      this.showEditLeaveType = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getJournal();
    },

    reload() {
      this.getJournal();
    },
    setIsConfirmed() {
      this.showWarning = false;
      this.deleteJournalEntry(this.journalToDelete.TimeoffJournalLineId);
    },

    handleDeleteButtonClick(journal) {
      // Handle the button click for the delete button

      this.title = `Delete ${journal.Type}`;
      this.message = `You are about to delete ${journal.Type} for ${journal.LeaveTypeName} beloging to ${journal.FullName}!`;
      this.journalToDelete = journal;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getJournal();
    },

    async getJournal() {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };
        const response = await axios.get(
          `${this.getOrganization}/timeoff/journal/${this.$ApiVersion}/request`,
          options
        );
        if (response.data.StatusCode == 200) {
          this.tableData = response.data.Data.find(
            (journal) =>
              journal.TimeoffJournalId ===
              this.getCurrentJournalId.TimeoffJournalId
          )?.TimeoffJournalLines;

        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
      this.loading = false;
    },
    // /{organization}/timeoff/journal/line/{timeoffJournalLineId}/v1/delete
    async deleteJournalEntry(TimeoffJournalLineId) {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };
        const response = await axios.delete(
          `${this.getOrganization}/timeoff/journal/line/${TimeoffJournalLineId}/${this.$ApiVersion}/delete`,
          options
        );
        if (response.data.StatusCode == 200) {
          this.handleDeleteOnSuccess();
          this.del_success = response.data.StatusMessage;
        } else {
          this.del_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.del_error = error.message;
      }
      this.loading = false;
    },
    // /{organization}/timeoff/journal/line/v1/post

    async handlePostButtonClick(TimeoffJournalLineId) {
      try {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            "Content-Type": "application/json",
          },
        };
        const response = await axios.post(
          `${this.getOrganization}/timeoff/journal/line/${this.$ApiVersion}/post`,
          JSON.stringify({
            TimeoffJournalLineId: TimeoffJournalLineId,
          }),
          options
        );

        if (response.data.StatusCode == 200) {
          this.create_success = response.data.StatusMessage;
          this.handleDeleteOnSuccess();
          setTimeout(() => {
            this.create_success = null;
          }, 2500);
        } else {
          // console.error(response.data.StatusMessage);
          this.$notify.error({
            title: "Error",
            message: "There has been a problem posting the record",
          });
        }
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Error",
          message: error.message,
          duration: 3000,
        });
      }
      this.loading = false;
    },

    editLeaveType(row) {
      this.showEditLeaveType = true;
      this.info = row;
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
